module.exports = __webpack_public_path__ + "img/ar3.b93d838f.jpg";